import { validateNodeDetails } from '../validate-node-details.js';
import { ValidationPhase } from '../validation-rule.js';
import { hasArchitectureAndDirectory } from './json-schema-rule.js';
/**
 * A model-backed, recursive {@link ValidationRule}: validates each node's referenced
 * detailed-architecture by re-entering the engine for the sub-architecture. The shared
 * {@link CachingTrackingResolver} caches loaded documents and tracks visited references, providing
 * cycle safety across the recursion.
 */
export class NodeDetailsValidationRule {
    constructor() {
        this.id = 'node-details';
        this.description = 'Recursively validate referenced detailed-architecture sub-documents';
        this.phase = ValidationPhase.RECURSIVE;
    }
    appliesTo(context) {
        return hasArchitectureAndDirectory(context);
    }
    async run(context) {
        // Re-enter the engine for each sub-architecture, threading the shared caching/tracking
        // resolver and deriving the mode from whether a pattern was resolved — reproducing the
        // historical dispatch between the with-pattern and pattern-less flows.
        const recursiveValidator = (arch, pattern, dir, dbg, references) => context.engine.validate({
            architecture: arch,
            pattern,
            timeline: undefined,
            mode: pattern !== undefined ? 'architecture-with-pattern' : 'architecture-only',
            schemaDirectory: dir,
            references,
            debug: dbg,
            engine: context.engine
        });
        const result = await validateNodeDetails(context.architecture, context.schemaDirectory, context.debug, recursiveValidator, context.references);
        return {
            jsonSchemaOutputs: result.jsonSchemaOutputs,
            spectralOutputs: result.spectralOutputs,
            hasErrors: result.hasErrors,
            hasWarnings: result.hasWarnings
        };
    }
}
//# sourceMappingURL=node-details-rule.js.map